import { LinearProgress, Typography, Box } from "@mui/material";

export default function PasswordStrengthBar({ password }) {
  const calcStrength = () => {
    let s = 0;
    if (password.length >= 5) s += 60;
    if (password.length >= 8) s += 20;
    if (password.length >= 12) s += 20;
    return s;
  };

  const strength = calcStrength();

  return (
    <Box sx={{ mt: 1 }}>
      <LinearProgress
        variant="determinate"
        value={strength}
        sx={{
          height: 8,
          borderRadius: 4,
          "& .MuiLinearProgress-bar": {
            backgroundColor:
              strength < 50 ? "red" : strength < 75 ? "#ffb300" : "#4caf50",
          },
        }}
      />
      <Typography sx={{ mt: 0.5, color: "#b0bec5", fontSize: 12 }}>
        Password Strength: {strength}%
      </Typography>
      <Typography sx={{ mt: 0.5, color: "#b0bec5", fontSize: 12 }}>
        Use at least 5 characters. Longer passwords are safer.
      </Typography>
    </Box>
  );
}
